var chunkToChildrenMap = {
	"1226": [
		3729,
		7281
	],
	"4498": [
		3729,
		7281
	],
	"5421": [
		4951,
		6778,
		427,
		3729,
		7281
	],
	"6369": [
		3729,
		7281
	],
	"7226": [
		3729,
		7281
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));